var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['to-top', _vm.isDark ? 'dark' : 'light'],on:{"mouseover":_vm.renderHover,"mouseleave":_vm.renderNormal,"click":_vm.scrollToTop}},[_c('UpArrow',{attrs:{"userHasHovered":_vm.hasHovered}}),_c('p',{style:({ color: _vm.myColors.onBackground })},[_vm._v("back to top")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }